// extracted by mini-css-extract-plugin
export default {"footerDivider":"Footer_footerDivider__f3+fT","footer":"Footer_footer__kXlYa","wrapElements":"Footer_wrapElements__WpeLg","logoImg":"Footer_logoImg__YKKZV","btn":"Footer_btn__29XvB"};